import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import './ButtonList.scss';

const makeKey = (b, i) => (b.id || `${i}`);

const ButtonList = (props) => {
  const { object, className, id, buttons, renderButtons, history, ...rest } = props;
  if (renderButtons) {
    return (
      <div className={classnames('grb-card-button-list', className)} id={id}>
        {renderButtons(props)}
      </div>
    );
  }
  if (!buttons || !buttons.length) {
    return false;
  }
  return (
    <div className={classnames('grb-card-button-list', className)} id={id}>
      {buttons.map((b, i) => {
        if (b.render) {
          return b.render({ ...rest, object });
        }
        const handleClick = b.onClick ? () => {
          b.onClick(object);
        } : (b.link && (() => (history && history.push(b.link)) || undefined));
        const ButtonOrIcon = (b.label || b.defaultButton) ? Button : IconButton;
        const button = (b.download || b.link) ? (
          <a
            id={b.id}
            className={classnames('grb-card-item-button', b.className)}
            href={b.downloadURL || b.link}
            download={b.download}
            aria-label={b.download ? 'Download' : 'link'}
            onClick={handleClick}
            key={makeKey(b, i)}
          >
            <ButtonOrIcon aria-label="download">
              {b.icon ? (
                <b.icon />
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" /></svg>
              )}
              {b.label}
            </ButtonOrIcon>
          </a>
        ) : (
          <ButtonOrIcon
            component={b.link ? Link : undefined}
            aria-label={b['aria-label']}
            className={classnames('grb-card-item-button', b.className)}
            id={b.id}
            onClick={handleClick}
            key={makeKey(b, i)}
            variant={b.variant}
            disabled={b.disabled}
          >
            {!!b.icon && <b.icon />}
            {b.label}
          </ButtonOrIcon>
        );
        if (b.tooltip) {
          return <Tooltip title={b.tooltip} key={makeKey(b, i)}>{button}</Tooltip>;
        }
        return button;
      })}
    </div>
  );
};

ButtonList.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  object: PropTypes.shape({}),
  buttons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.string,
    tooltip: PropTypes.string,
    download: PropTypes.bool,
    downloadURL: PropTypes.string,
    defaultButton: PropTypes.bool,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  renderButtons: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

ButtonList.defaultProps = {
  id: undefined,
  className: undefined,
  object: undefined,
  buttons: undefined,
  renderButtons: undefined,
  history: undefined,
};

export default ButtonList;
